export default __webpack_public_path__ + "static/media/012-Groot.83e43354.svg";